import { jsx } from "react/jsx-runtime";
import { StyledParagraph } from "@zillow/constellation";
import { usePageProps, negativeMarginMixin } from "@zillow/zrs-cms";
import "react";
import styled from "styled-components";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
import makeContentInteractive from "../../util/makeSpansInteractive.esm.js";
const CMSParagraph = /* @__PURE__ */ styled(StyledParagraph).withConfig({
  displayName: "Paragraph__CMSParagraph",
  componentId: "sc-1rdunrc-0"
})(["", ""], negativeMarginMixin);
const BlockParagraph = ({
  attrs,
  index
}) => {
  const {
    content,
    textAlign = "inherit",
    margin,
    ...rest
  } = attrs;
  const pageProps = usePageProps();
  const isPost = usePlacement() === "post";
  if (!content || !content.trim()) {
    return null;
  }
  const interactiveContent = makeContentInteractive(content, {
    pageProps,
    blockAttributes: attrs
  });
  const attributes = {
    as: "p",
    fontType: "body",
    marginBottom: "sm",
    fontColor: "",
    textAlign,
    ...rest
  };
  return /* @__PURE__ */ jsx(CMSParagraph, { ...attributes, ...isPost ? {
    marginBottom: "sm"
  } : margin, children: interactiveContent }, index);
};
export {
  BlockParagraph as default
};
